import { useIdentity } from '$api-clients/hooks';

export const useUserTeamMembers = (userId?: string) => {
  const { data, isLoading, error } = useIdentity(
    '/users/{userId}/team-members',
    userId
      ? {
          params: {
            path: {
              userId,
            },
          },
        }
      : null,
  );

  return {
    memberships: data?.data ?? [],
    loading: isLoading,
    error,
  };
};
